import create from 'zustand'

export interface Course {
  firebaseId: string;
  id: string;
  name: string;
}

export const useCourses = create<Course[]>(() => ([]))
